import React from 'react'

import Style from './style'

import DefaultModal from 'shared/ui/DefaultModal'
import DefaultButton from 'shared/ui/DefaultButton'
import useConfirmModalAtom from 'shared/model/useConfirmModalAtom'

const ConfirmModal = () => {
	const [label, , confirmEvent, cancelEvent, showClose, title] =
		useConfirmModalAtom()

	return (
		<DefaultModal closeEvent={cancelEvent} upper>
			<Style.Container>
				{title && <Style.Title>{title}</Style.Title>}
				<Style.Label>{label}</Style.Label>
			</Style.Container>
			<Style.BtnDiv>
				<DefaultButton small clickEvent={confirmEvent}>
					확인
				</DefaultButton>
				{showClose && (
					<DefaultButton small clickEvent={cancelEvent} minor>
						취소
					</DefaultButton>
				)}
			</Style.BtnDiv>
		</DefaultModal>
	)
}

export default ConfirmModal
